import superviseBillApi from '@/api/park/superviseBill';
import XEUtils from 'xe-utils';
export default {
  methods: {
    // 按钮处理事件
    btnHandler(name) {
      this[name]();
    },
    // 编辑按钮
    edit() {
      this.isDisabledGoods = false;
      this.isShowDownBtn = false;
      this.getDetailData();
    },
    // 查看按钮
    view() {
      this.isDisabledGoods = true;
      this.isShowDownBtn = true;
      this.getDetailData();
    },
    // 保存按钮
    async save() {
      this.saveOrSubmitHandler(0);
    },
    // 提交按钮
    submit() {
      this.saveOrSubmitHandler(1);
    },
    // 将数组转换为字符串
    arrayToString(array) {
      let str = '';
      array.forEach((element) => {
        str += element + ',';
      });
      str = str.substring(0, str.length - 1);
      return str;
    },
    // 提交或者保存处理事件，operateFlag 0保存,1提交
    async saveOrSubmitHandler(operateFlag) {
      let postData = await this.getDetailData();
      postData.goodsType = this.arrayToString(postData.goodsType);
      postData.goodsCategory = this.arrayToString(postData.goodsCategory);
      delete postData.collaterals;
      console.log(postData, 'postData');
      if (!postData) return;
      const {
        data: { code, msg },
      } = await this.$axios.post(superviseBillApi.SAVE_BILL, {
        ...postData,
        operateFlag,
      });
      if (code === 0) {
        this.$message.success(msg);
        // 关闭当前的tag
        let name;
        let path;
        if (this.currentStatus == 'edit') {
          path = '/park/superviseBill/edit';
          name = 'edit';
        } else {
          path = '/park/superviseBill/supervisionBillDetail';
          name = 'supervisionBillDetail';
        }
        this.$store.dispatch('tagsView/delView', {
          path: path,
          name: name,
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/park/superviseBill/management');
      } else {
        this.$message.error(msg);
      }
    },
    // 取消按钮
    cancel() {
      // 关闭当前的tag
      let name;
      let path;
      if (this.currentStatus == 'edit') {
        path = '/park/superviseBill/edit';
        name = 'edit';
      } else {
        path = '/park/superviseBill/supervisionBillDetail';
        name = 'supervisionBillDetail';
      }
      this.$store.dispatch('tagsView/delView', {
        path: path,
        name: name,
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
      this.$router.push('/park/superviseBill/management');
    },
    // 通过按钮
    pass() {
      this.approvalOrRejectHandlerByNo('01');
    },
    // 驳回按钮
    refuse() {
      this.approvalOrRejectHandlerByNo('02');
    },
    // 提交审批
    async approvalOrRejectHandlerByNo(approvalResult) {
      const baseFormData = await this.$refs.billApprovalFormRef.getTableData();
      const postData = {
        ...baseFormData, // 表单表格数据
        approvalResult,
        approvalDate: this.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        approvalDepartmentName: this.userInfo.departmentName,
        approvalDepartmentNo: this.userInfo.departmentCode,
        departmentCodes: [this.userInfo.departmentCode],
        approvalPersonName: this.userInfo.userName,
        approvalPersonNo: this.userInfo.userCode,
        approvalContractType: '02',
        approvalDataNo: this.formData.billNo,
        id: this.$route.query.id,
        companyCode: this.formData.companyCode,
        companyName: this.formData.companyName,
        departmentName: this.formData.departmentName,
      };
      console.log(postData, 'postData');
      const { data } = await this.$axios.post(superviseBillApi.APPROVAL_SUPERVISE_BILL, postData);
      console.log(data, '接口响应值');
      if (data.code == 0) {
        this.$message.success(data.msg);
        this.$store.dispatch('tagsView/delView', {
          path: '/park/superviseBill/billApproval',
          name: 'billApproval',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        const path = {
          path: '/park/superviseBill',
          name: 'management',
          meta: {
            keepAlive: true,
            title: '监管单单据列表',
          },
        };
        this.$router.push(path);
      } else {
        this.$message.error(data.msg);
      }
    },
    // 保存抽检
    async saveCheck() {
      // let postData = await this.getDetailData();
      let baseFormData = await this.$refs.baseInfoFormRef.getTableData();
      const { tableData: superviseBillChecks, deleteCheckLineIds } =
        await this.$refs.samplingTableRef.getValidateTableData();
      let postData = {
        id: baseFormData.id,
        superviseBillChecks,
        deleteCheckLineIds,
      };
      const res = await this.$axios.post(superviseBillApi.SAVE_CHECK_BILL, postData);
      if (res.data.code == 0) {
        this.$message.success('操作成功');
        // 关闭当前的tag
        let name;
        let path;
        if (this.currentStatus == 'edit') {
          path = '/park/superviseBill/edit';
          name = 'edit';
        } else {
          path = '/park/superviseBill/supervisionBillDetail';
          name = 'supervisionBillDetail';
        }
        this.$store.dispatch('tagsView/delView', {
          path: path,
          name: name,
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push('/park/superviseBill/management');
      } else {
        this.$message.error(res.data.msg);
      }
      console.log('保存抽检信息', res);
      console.log();
    },
    // 获取页面表单表格数据
    async getDetailData() {
      // 1.表单数据
      let baseFormData = await this.$refs.baseInfoFormRef.getTableData();
      if (baseFormData.approvalType == ' ' || baseFormData.approvalType == null) {
        baseFormData.approvalType = 'create';
      }
      console.log(baseFormData, '基本信息表单');
      baseFormData.departmentCodes = [this.userInfo.departmentCode];
      baseFormData.adminFlag = this.userInfo.adminFlag;
      // 2.质押物信息
      const { tableData: collateralLines, deleteCollateralLineIds } =
        await this.$refs.pledgeTableRef.getValidateTableData();
      // 3.附件
      const attachments = this.$refs.fileTableRef.getTableData();
      console.log(attachments, '上传的附件');
      // 4.审批数据
      // const
      const postData = {
        ...baseFormData,
        collateralLines,
        attachments,
        deleteCollateralLineIds,
      };
      return postData;
    },
    //表格日期回显
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
  },
};
